import { call, select } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import {
  remove
} from '../redux/followedCards'

export default function * requestUnfollowCard (action) {
  const { id } = action.payload

  const state = yield select()

  const followedCard = state.kanbo.followedCards.followedCardsById[id]

  if (!followedCard) return

  const optimisticAction = yield optimisticPut(remove({
    id
  }))

  try {
    yield call(apiAction, 'RemoveObservedTag', {
      name: 'card-' + id
    })

    yield optimisticAction.commit()
  } catch (error) {
    yield optimisticAction.revert()

    throw error
  }
}
